import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from 'firebase/firestore';

export function createNotificacionesRepository({ getFirebase }) {
  function subscribeNotificaciones(uid, onData, onError) {
    const { db } = getFirebase();
    const q = query(
      collection(db, 'usuarios', uid, 'notificaciones'),
      orderBy('creadoEn', 'desc'),
      limit(40)
    );
    return onSnapshot(
      q,
      (snap) => {
        const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        onData(items);
      },
      onError || console.error
    );
  }

  async function marcarLeida(uid, notifId) {
    const { db } = getFirebase();
    await updateDoc(doc(db, 'usuarios', uid, 'notificaciones', notifId), {
      leida: true,
      actualizadoEn: serverTimestamp(),
    });
  }

  return { subscribeNotificaciones, marcarLeida };
}
